import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { PaymentallocationApi } from '../../redux/portfolio/portfolio';
import toast from 'react-hot-toast';
import { useNavigate } from "react-router-dom";
// import { setuserDetail } from '../../redux/auth/auth';
import { PaymentallocationApi } from '../../../redux/portfolio/portfolio';
import { setuserDetail } from '../../../redux/auth/auth';

const numberToWords = (num) => {
    const a = [
        '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
        'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen',
        'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'
    ];
    const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    const convert = (n) => {
        if (n < 20) return a[n];
        if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
        if (n < 1000) return a[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " and " + convert(n % 100) : "");
        if (n < 100000) return convert(Math.floor(n / 1000)) + " Thousand" + (n % 1000 ? " " + convert(n % 1000) : "");
        if (n < 10000000) return convert(Math.floor(n / 100000)) + " Lakh" + (n % 100000 ? " " + convert(n % 100000) : "");
        return convert(Math.floor(n / 10000000)) + " Crore" + (n % 10000000 ? " " + convert(n % 10000000) : "");
    };

    if (!num || isNaN(num)) return '';
    return convert(Number(num)) + " Only";
};

const Allocation = () => {
    const navigate = useNavigate();
    const userId = useSelector(state => state.auth.userDetail.id);
    const dispatch = useDispatch();
    const userDetail = useSelector(state => state.auth.userDetail)
    const [amounts, setAmounts] = useState({
        portfolioAmt: "",
    });

    const [validationErrors, setValidationErrors] = useState({});

    const handleAmountChange = (key) => (e) => {
        const rawValue = e.target.value.replace(/[^0-9]/g, ""); // Only digits
        const formattedValue = new Intl.NumberFormat("en-IN").format(Number(rawValue));

        setAmounts((prev) => ({
            ...prev,
            [key]: formattedValue,
        }));

        setValidationErrors((prevErrors) => ({
            ...prevErrors,
            [key]: "",
        }));
    };
    const validation = () => {
        let errors = {};
        const wealth = Number(amounts.portfolioAmt.replace(/,/g, ''));
        if (!wealth || wealth <= 0 || wealth < 150000) {
            errors.portfolioAmt = "Minimum amount is ₹1,50,000";
        }

        setValidationErrors(errors);
        return Object.keys(errors).length === 0;
    };
    const handlePortfolio = async () => {
        if (!validation()) return;
        const payload = {
            portfolioAmt: Number(amounts.portfolioAmt.replace(/,/g, '')),
            // userId: userId
        };
        const response = await dispatch(PaymentallocationApi(payload));
        if (PaymentallocationApi.fulfilled.match(response)) {
            toast.success(response?.payload?.message);
            dispatch(setuserDetail(payload))
            navigate("/portfolio");
        }
    };
    return (
        <>
            <section id="create-portfolio" class="py-5">
                <div class="container">
                    <div class="rounded-3 border p-3 bg-white">
                        <div class="row g-3">
                            <div class="col-md-9">
                                <h1 class="fs-3 fw-bold ">Hello {userDetail?.firstName ?? ''} {userDetail?.lastName ?? ''},</h1>
                                <p>Let's get started with setting up your portfolio.</p>
                                <p class="mt-4">Please enter your initial investment amount to create a personalized portfolio tailored to your financial goals.</p>
                                <div class="d-flex gap-5 d-none">
                                    <div>
                                        <small class="text-muted">Min. Investment</small>
                                        <h5>₹5,00,000</h5>
                                    </div>
                                    <div>
                                        <small class="text-muted">No of Stocks</small>
                                        <h5>11</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="py-3 text-center">
                                    <div class="form-floating">
                                        <input
                                            type="text"
                                            class="form-control fw-bold"
                                            id="floatingInput"
                                            placeholder="1005000"
                                            style={{ "font-size": "1.5rem; letter-spacing: 1px" }}
                                            value={amounts.portfolioAmt}
                                            onChange={handleAmountChange("portfolioAmt")}
                                        />
                                        <label for="floatingInput">Enter Investment Amount</label>
                                        {validationErrors.portfolioAmt && (
                                            <div className="text-danger mt-1">
                                                {validationErrors.portfolioAmt}
                                            </div>
                                        )}
                                    </div>
                                    <small class="d-block fst-italic mt-2">
                                        {numberToWords(amounts.portfolioAmt.replace(/,/g, ''))}
                                    </small>
                                    <button
                                        // type="submit"
                                        class="btn btn-dark btn-lg w-100 mt-2 rounded-5 mt-3"
                                        onClick={() => handlePortfolio()}
                                    >Continue</button>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </section>
            <div className="py-5 d-none">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-6">
                            <div className="border p-3 p-md-5 rounded-3 shadow-sm bg-secondary bg-opacity-10">
                                <h1 className="fs-4">Hi, {userDetail?.firstName ?? ''} {userDetail?.lastName ?? ''}</h1>
                                <p className="fst-italic ">
                                    Welcome, Let's create your initial portfolio
                                </p>
                                <hr />

                                {/* 🛍️ Initial Investment */}
                                <p className="mb-0 mt-4 fs-4">🛍️</p>
                                <p className="mb-2">
                                    <i>Please enter your initial investment amount</i>{" "}
                                    <i className="fa fa-info-circle text-secondary" />
                                </p>
                                <input
                                    type="text"
                                    className="w-75 form-control form-control-lg"
                                    placeholder="Enter amount in ₹"
                                    value={amounts.portfolioAmt}
                                    onChange={handleAmountChange("portfolioAmt")}
                                />
                                {validationErrors.portfolioAmt && (
                                    <div className="text-danger mt-1">
                                        {validationErrors.portfolioAmt}
                                    </div>
                                )}
                                <small className="fst-italic text-success d-block">
                                    {numberToWords(amounts.portfolioAmt.replace(/,/g, ''))}
                                </small>


                                {/* Submit Button */}
                                <button
                                    className="btn mt-4"
                                    style={{
                                        // height: '45px', 
                                        background: 'linear-gradient(to right, #C609FA, #3959FE, #0E9EEE)',
                                        color: 'white', // or another readable solid color
                                        // height: '45px',
                                        border: 'none',
                                    }}
                                    onClick={handlePortfolio}
                                >
                                    Create My Portfolio
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Allocation;
